export const THEME_NAME = 'dark-theme'
const hasStorageDarkTheme = (): boolean => {
  const hasStorageDarkTheme = localStorage.getItem(THEME_NAME)
  if (!hasStorageDarkTheme) return false
  const hasStorageDarkThemeValue = JSON.parse(hasStorageDarkTheme)
  return Boolean(hasStorageDarkThemeValue)
}
const prefersDarkMode = window.matchMedia(
  '(prefers-color-scheme: dark)'
).matches
const isDarkThemeInStorage = hasStorageDarkTheme()

export const defaultTheme =
  isDarkThemeInStorage !== null ? isDarkThemeInStorage : prefersDarkMode
